export default {
    // 德语
    LOCALE_HTML: {
        'msg.language': 'de',
        'msg.title': 'Titel',
        'msg.type': 'Fragekategorie',
        'msg.des': 'Problembeschreibung',
        'msg.phone': 'Telefonnummer',
        'msg.regionCode': 'Vorwahl',
        'msg.email': 'Email',
        'msg.choose': 'Typ Auswählen',
        'msg.detail': 'Nachrichtendetails',
        'msg.back': 'Zurück',
        'your.msg': 'Ihre Nachricht',
        'msg.record': 'Nachrichtenaufzeichnung',
        'msg.success': 'Nachricht erfolgreich',
        'to.record': 'Gehe zum Nachrichteneintrag',
        completed: 'Fertig',
        submit: 'Einreichen',
        'success.desc': 'Ihre Nachricht wurde erfolgreich übermittelt, danke',
        'msg.form.input': 'Eingeben',
        'msg.reply': 'Antworten',
        'comment.suc': 'Vielen Dank für Ihre Bewertung!',
        'comment.fail': 'Übermittlung fehlgeschlagen',
        'comment.placeholder':
            'willkommen zur Anregungen der unseren Dienstleistungen ',
        'reply.suc': 'Übermittlung eingereicht!',
        'reply.fail': 'Bitte geben Sie Ihre Antwort ein',
        'reply.placeholder': 'Bitte geben Sie Ihre Antwort ein',
        'msg.more': 'Mehr Sehen',
        'msg.collapse': 'Wegräumen',
        'msg.myservice': 'Meine Servicebewertung',
        'msg.evaluate': 'Servicebewertung',
        'msg.evaluateTitle': 'Servicebewertung',
        'msg.score': 'Ergebnis:',
        'msg.remark': 'Bemerkungen:',
        'msg.status.created': 'Erstellt',
        'msg.status.pending': 'Anstehend',
        'msg.status.processing': 'Behandelnd',
        'msg.status.solved': 'Fertig',
        'msg.service.reply': 'Antwort Vom Kundenservice',
        'msg.my.reply': 'Meine Antwort',
        'msg.toast.des': 'Problembeschreibung ist leer',
        'msg.toast.type': 'Fragenkategorie ist leer',
        'msg.toast.title': 'Titel ist leer',
        'msg.toast.none': 'Kann nicht leer sein',
        'msg.toast.noAnnex': 'Anhänge hochladen',
        'msg.toast.noEmail': 'Email darf nicht leer sein',
        'msg.toast.noTel': 'Telefonnummer darf nicht leer sein',
        'msg.toast.noRegionCode': 'Die Vorwahl darf nicht leer sein',
        'msg.toast.noZone': 'Bitte wählen Sie eine Zeitzone aus',
        'msg.toast.noDateTime': 'Bitte wählen Sie Datum und Uhrzeit aus',
        'msg.toast.email': 'Bitte geben Sie eine gültige Email ein',
        'msg.toast.tel': 'Bitte geben Sie eine gültige Telefonnummer ein',
        'msg.toast.regionCode': 'Bitte wählen Sie die Vorwahl',
        'msg.toast.num': 'Bitte geben Sie die richtige Nummer ein',
        'msg.toast.annex': 'Anhänge hochladen',
        'msg.toast.char': 'Bitte geben Sie die richtigen Zeichen ein',
        'msg.list.none': 'Keine Daten',
        'msg.form.choose': 'Auswählen',
        'msg.form.chooseZone': 'Wähle Zeitzone aus',
        'msg.form.chooseTime': 'Zeit wählen',
        'msg.form.chooseDate': 'Datum wählen',
        'msg.form.sure': 'OK',
        'msg.form.search': 'Suchen nach...',
        'msg.form.uploadError': 'Falsches Format',
        'msg.form.uploadXss':
            'Hochladen fehlgeschlagen, Dateiinhalt enthält illegales Skript',
        'msg.update.time': 'Aktualisiert am',
        'msg.replace.images': 'Bild',

        MSG016: 'Gelöst',
        MSG017: 'Ungelöst',
        MSG019: 'Einreichen',
        MSG072: 'Das Bewertungslabel darf nicht leer sein! ',
        MSG073: 'Evaluierungssprache darf nicht leer sein! ',
        MSG074: 'Etikett:',
        MSG075: 'Ist es Gelöst:',
        MSG076: 'Bitte wählen Sie aus, ob das Problem gelöst ist',
        MSG015: 'Hat dieses Ticket Ihr Problem gelöst?',

        'file.size.limit': 'Dateigröße darf 50 MB nicht überschreiten',
        'detail.file.limit': '15 höchstens, die Größe überschreitet nicht 50M',
        'form.question.des.tip': 'Bitte geben Sie eine Problembeschreibung ein',
        'form.title.tip': 'Bitte geben Sie einen Title ein',
        'form.class.tip': 'Bitte wählen Sie die Fragekategorie  ein',
        'upload.file': 'Anhänge Hochladen',
        'file.count.limit': 'Sie können nur bis zu 15 Anhänge hochladen',
        'select.search.placeholder': 'Suche nach dem Stichwort',
        'msg.form.sizeError1':
            'Bitte laden Sie Anhänge hoch, die kleiner als 5M sind',
        'msg.form.sizeError2':
            'Bitte laden Sie Anhänge hoch, die kleiner als 50M sind',
        'msg.form.submit': 'einreichen...',
        'msg.form.upload': 'Hochladen...',
        'msg.email.tip1': 'Habe deine Nachricht nicht gefunden',
        'msg.email.tip2':
            'Wenn Sie bereits eine Nachricht hinterlassen haben, können Sie diese per Email-Verifizierung überprüfen',
        'msg.email.tip3': 'Email-Verifizierung Starten',
        'msg.email.noData': 'Keine Daten unter Girokonto',
        'email.verify.tip':
            'Geben Sie die Email-Adresse ein, die Sie beim Hinterlassen einer Nachricht verwendet haben',
        'email.input.placeholder': 'Bitte geben Sie die Email-Adresse ein',
        'email.submit': 'Email Senden',
        'email.rules.error': 'Bitte geben Sie eine gültige Email ein',
        'email.code.tip':
            'Die Email wurde gesendet, bitte geben Sie den erhaltenen Bestätigungscode ein',
        'email.code.placeholder': 'Bestätigungscode eingeben',
        'email.code.submit': 'Jetzt Ansehen',
        'email.notFind.customer': 'Kundeninformationen nicht gefunden',
        'email.code.wrong':
            'Der Bestätigungscode ist falsch, bitte erneut eingeben',
        'email.code.expired':
            'Der Bestätigungscode ist abgelaufen, bitte bestätigen Sie die Email erneut',
        'email.code': 'Bestätigungscode',
        'email.send.frequently':
            'Der Vorgang ist zu häufig, bitte versuchen Sie es später erneut',
        'comment.fail.400133': 'Dieses Ticket wurde bewertet',
        'not.get.user.info': 'Ihre Informationen können nicht abgerufen werden',
        'user.verify.tip':
            'Sie müssen dies überprüfen, bevor Sie den Inhalt der Nachrichtenliste anzeigen können',
        'verify.type.email': 'Email-Überprüfung',
        'verify.text': 'Validieren',
        'cancel.text': 'Abbrechen',
        'get.verify.code': 'Überprüfungscode Erhalten',
        'reGet.verify.code': 'Reacquire',
        'verify.by.email.tip':
            'Der Verifizierungscode wird per Email an die von Ihnen eingegebene Email-Adresse gesendet.',
        'verify.type.phone': 'SMS-Verifizierung',
        'phone.placeholder': 'Bitte geben Sie Ihre Telefonnummer ein',
        'verify.by.phone.tip':
            'Der Verifizierungscode wird per SMS an die von Ihnen eingegebene Telefonnummer gesendet',
        'phone.error': 'Bitte geben Sie die richtige Telefonnummer ein',
        'phone.errorCode400150': 'Häufige Zusendung von Verifizierungscodes',
        'phone.errorCode400233': 'Die SMS-Vorlage kann nicht leer sein',
        'phone.errorCode400234': 'Unzureichendes SMS-Guthaben für Marketing',
        'phone.errorCode400235':
            'SMS-Guthaben für Benachrichtigungen unzureichend',
        'phone.errorCode400247':
            'SMS-Konfigurationsfehler des Arbeitsauftrags-Plugins',
        'phone.errorCode4400248': 'SMS-Vorlage konnte nicht abgerufen werden',
        'phone.errorCode400249':
            'Diese Nummer ist nicht die Telefonnummer eines bestehenden Benutzers',
        'phone.errorCode400250':
            'Der Verifizierungscode ist abgelaufen, bitte holen Sie ihn erneut ab',
        'msg.you.reply': 'Hat Ihnen geantwortet',
        'msg.no.reply':'keine Antwort',
    },
    LOCALE_REQUEST: {
        400016: 'Das Abrufen von Arbeitsauftragsinformationen ist abgelaufen, bitte aktualisieren!'
    },
    LOCALE_SYSTEM: {
        MSG005: ({ name }) =>
            `Conversation with ${name} has been ended temporarily`,
        MSG012: (color) =>
            ` You can <span style="color:${color};text-decoration:underline;" class="js-leave-msg">Leave message</span>`,
        MSG013: 'Send'
    },
    LOCALE_EDITOR: {
        editor: {
            base: {
                remove: 'Löschen',
                cancel: 'Abbrechen',
                confirm: 'OK',
                inert: 'Einfügung',
                width: 'Breite',
                height: 'Hoch'
            },
            controls: {
                clear: 'Klarer Inhalt',
                undo: 'Widerrufen',
                redo: 'Wiederholen',
                fontSize: 'Schriftgröße',
                lineHeight: 'Zeilenhöhe',
                letterSpacing: 'Wortabstand',
                textIndent: 'Absatzeinzug',
                increaseIndent: 'Einzug Vergrößern',
                decreaseIndent: 'Einrückung Reduzieren',
                border: 'Rahmen',
                color: 'Farbe',
                textColor: 'Textfarbe',
                backgroundColor: 'Hintergrundfarbe',
                tempColors: 'Temporäre Farbe',
                bold: 'Deutlich',
                italic: 'Kursivschrift',
                underline: 'Unterstreichen',
                strikeThrough: 'Durchgestrichen',
                fontFamily: 'Die Schriftart',
                textAlign: 'Textausrichtung',
                alignLeft: 'Linksbuendig',
                alignCenter: 'Im Zentrum',
                alignRight: 'Rechts',
                alignJustify: 'Beide Enden',
                floatLeft: 'Nach Links Schweben',
                floatRight: 'Schweben Rechts',
                superScript: 'Hochgestellt',
                subScript: 'Index',
                removeStyles: 'Klarer Stil',
                headings: 'Titel',
                header: 'Titel',
                normal: 'Konventionell',
                orderedList: 'Bestellliste',
                unorderedList: 'Ungeordnete Liste',
                blockQuote: 'Zitieren',
                code: 'Der Code',
                link: 'Verknüpfung',
                unlink: 'Klarer Link',
                hr: 'Horizontale Linie',
                media: 'Medien',
                mediaLibirary: 'Medienbibliothek',
                emoji: 'Kleiner Ausdruck',
                fullscreen: 'Vollbild',
                exitFullscreen: 'Beenden Sie den Vollbildmodus'
            },
            linkEditor: {
                textInputPlaceHolder: 'Geben Sie den Linktext ein',
                linkInputPlaceHolder: 'Geben Sie die Linkadresse ein',
                inputWithEnterPlaceHolder:
                    'Geben Sie die Linkadresse ein und drücken Sie die Eingabetaste',
                openInNewWindow: 'In einem neuen Fenster öffnen',
                removeLink: 'Link entfernen'
            },
            audioPlayer: {
                title: 'Audiodatei abspielen'
            },
            videoPlayer: {
                title: 'Videodatei abspielen',
                embedTitle: 'Eingebettete Medien'
            },
            media: {
                image: 'Bild',
                video: 'Video',
                audio: 'Audio',
                embed: 'Eingebettete Medien'
            }
        },
        finder: {
            remove: 'Löschen',
            cancel: 'Abbrechen',
            confirm: 'OK',
            insert: 'Ausgewähltes Element Einfügen',
            width: 'Breite',
            height: 'Hoch',
            image: 'Bild',
            video: 'Video',
            audio: 'Audio',
            embed: 'Eingebettete Medien',
            caption: 'Medienbibliothek',
            dragTip: 'Klicken Oder Ziehen Sie die Datei Hierher',
            dropTip: 'Zum Hochladen Freigeben',
            selectAll: 'Wählen Sie Alle',
            deselect: 'Auswahl Abbrechen',
            removeSelected: 'Ausgewähltes Element Löschen',
            externalInputPlaceHolder: 'Ressourcenname|Ressourcenadresse',
            externalInputTip:
                'Verwenden Sie „|“, um Ressourcennamen und Ressourcenadresse zu trennen',
            addLocalFile: 'Fügen Sie Lokale Ressourcen Hinzu',
            addExternalSource: 'Webressource Hinzufügen',
            unnamedItem: 'Projekt Ohne Titel',
            confirmInsert: 'Ausgewähltes Element Einfügen'
        }
    }
}
